import React,{useState,useEffect} from "react";
import Header from "./Header.js";
import "../Style/Home.css";
import sec1 from "../Assets/sec1.png";
import skin1 from "../Assets/Skin/skin1.png";
import skin2 from "../Assets/Skin/skin2.png";
import skin3 from "../Assets/Skin/skin3.png";
import skin4 from "../Assets/Skin/skin4.png";
import skin5 from "../Assets/Skin/skin5.png";
import skin6 from "../Assets/Skin/skin6.png";
import skin7 from "../Assets/Skin/skin7.png";
import female1 from "../Assets/female/female1.png";
import female2 from "../Assets/female/female2.png";
import female3 from "../Assets/female/female3.png";
import female4 from "../Assets/female/female4.png";
import female5 from "../Assets/female/female5.png";
import female6 from "../Assets/female/female6.png";
import female7 from "../Assets/female/female7.png";
import g1 from "../Assets/general/g1.png";
import g2 from "../Assets/general/g2.png";
import g3 from "../Assets/general/g3.png";
import g4 from "../Assets/general/g4.png";
import g5 from "../Assets/general/g5.png";
import g6 from "../Assets/general/g6.png";
import g7 from "../Assets/general/g7.png";
import sec4 from "../Assets/sec4.png";
import sec5 from "../Assets/sec5.png";
import sec6 from "../Assets/sec6.png";
import ContentCard from "./ContentCard.js";
import OnlineConsultation from "./OnlineConsultation.js";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import GetAnAppointment from "./GetAnAppointment.js";
import TestimonialData from "./TestimonialData.js";
import BookAppointment from "./BookAppointment.js";
import { useAppointment } from "./AppointmentContext.js";
import { useLocation } from "react-router-dom";
import HeaderCaraousel from "./HeaderCaraousel.js";
import VideoCaraousel from "./VideoCaraousel.js";
import { useAuth } from "./UserContext.js";
const Home = () => {
  const { appointmentData, handleAppointment } = useAppointment();
  const { options } = useAuth();
  const isMobile = window.innerWidth <= 768;
  const location = useLocation();
  const message = location.state;

  if (message?.message === "paymentsuccess") {
    alert("Appointment booked successfully.");
    message.message = "";
  }
  const skin = {
    heading: {
      heading: "Homeopathy For Skin",
      para: "Homeopathic remedies for skin are treatments derived from the principles of homeopathy, a system of alternative medicine. In homeopathy, the idea is to treat the whole person rather than just focusing on specific symptoms. Remedies for skin conditions are formulated based on the belief that substances that cause symptoms in healthy individuals can be used in diluted forms to treat similar symptoms in individuals who are ill or suffering from skin conditions.",
    },
    content: [
      {
        imageUrl: skin1,
        name: "Warts & Moles",
        desc: "warts and moles have a broad base and go deep into the skin, but on a mole, the skin remains soft. Warts, however, appear as rough skin, possibly with points on the surface.",
        btn: "Know more",
      },
      {
        imageUrl: skin2,
        name: "Acnes, Pimples",
        desc: "Acne is a skin condition that occurs when your hair follicles become plugged with oil and dead skin cells. It causes whiteheads, blackheads or pimples.",
      },
      {
        imageUrl: skin3,
        name: "All types of Tinea",
        desc: "Tinea is a contagious fungal skin infection. The most commonly affected areas include the feet, groin, scalp. which is a misleading name as no worm is involved.",
      },
      {
        imageUrl: skin4,
        name: "Hair Fall",
        desc: "Hair loss can affect just your scalp or your entire body, and it can be temporary or permanent. It can be the result of heredity, hormonal changes, medical conditions .",
      },
      {
        imageUrl: skin5,
        name: "Alopecia",
        desc: "Sudden hair loss that starts with one or more circular bald patches that may overlap.Alopecia areata occurs when the immune system attacks hair follicles and may be brought on by severe stress.",
      },
      {
        imageUrl: skin6,
        name: "Psoriasis",
        desc: "Psoriasis is thought to be an immune system problem. Triggers include infections, stress and cold.The symptom is thick skin patches typically seen on elbows, knees, and lower back .",
      },
      {
        imageUrl: skin7,
        name: "Vitiligo, Leucoderma",
        desc: "Vitiligo occurs when pigment-producing cells die or stop functioning. Loss of skin color can affect any part of the body, including the mouth, hair and eyes.",
      },
    ],
  };
  const female = {
    heading: {
      heading: "Homeopathy For Female",
      para: "Homeopathy for females refers to the practice of using homeopathic remedies to address health issues or conditions that are specific to women. Homeopathy is a holistic system of medicine that uses highly diluted natural substances to stimulate the body’s own healing process. In the context of female health, homeopathic treatments may be used for a variety of concerns.",
    },
    content: [
      {
        imageUrl: female1,
        name: "Infertility (Male / Female)",
        desc: "Infertility is a disease of the male or female reproductive system that occurs when a couple is unable to conceive after a year or more of regular, unprotected sex",
        btn: "Know more",
      },
      {
        imageUrl: female2,
        name: "Ovarian Cyst ,PCOD",
        desc: "Ovarian cysts are fluid-filled sacs that form on or within the ovaries, while polycystic ovarian disease (PCOD) is a hormonal imbalance that can cause cysts to form on the ovaries.",
      },
      {
        imageUrl: female3,
        name: "Menses Irregularities",
        desc: "Menstrual irregularities, also known as irregular periods, are characterized by abnormal variations in the frequency, duration, or amount of menstrual bleeding.",
      },
      {
        imageUrl: female4,
        name: "Prolapse, Fibroids Uterus",
        desc: "A fibroid can prolapse into the vagina, and a prolapsed fibroid can mimic uterine inversion. tumors that grow in the uterus, and they can bulge from the inside or outside of the uterus. ",
      },
      {
        imageUrl: female5,
        name: "Leucorrhea",
        desc: "It is known as fluor albus, is a vaginal discharge that can be clear, white, yellowish, or greenish in color. It usually thin and has a mild odor, and doesn't cause itching or a strong foul smell",
      },
      {
        imageUrl: female6,
        name: "Miscarriage",
        desc: " the unexpected ending of a pregnancy in the first 20 weeks of gestation. Just because it's called a “miscarriage” doesn't mean you did something wrong in carrying the pregnancy.",
      },
      {
        imageUrl: female7,
        name: "Breast Tumor",
        desc: "tumor that grows in or around the breast tissue, mainly in the milk ducts and glands. A tumor usually its calcium deposit that develops as a result of abnormal cell growth.",
      },
    ],
  };

  const general = {
    heading: {
      heading: "General Homeopathy ",
      para: "Homeopathy is a system of alternative medicine based on the principle of like cures like. It involves using highly diluted substances, typically plant, mineral, or animal extracts, to treat various health conditions. The central idea is that these substances, when administered in small amounts, stimulate the body's natural healing abilities. Homeopathy was founded by Samuel Hahnemann in the late 18th century and emphasizes individual treatment, focusing on the person's overall physical, mental, and emotional state. It operates under the belief that symptoms of illness are a reflection of an underlying imbalance within the body that can be corrected by matching the right remedy.",
    },
    content: [
      {
        imageUrl: g1,
        name: "Cervical, Lumber  Spondylitis and  Spondylosis",
        desc: "The neck, or to the neck of any organ or structure. Cervical lymph nodes  Cervical cancer refers to cancer of the uterine cervix, which is the lower, narrow end of the uterus.",
        btn: "Know more",
      },
      {
        imageUrl: g2,
        name: "Kidney Diseases",
        desc: " kidneys are damaged and can't filter blood the way they should. You are at greater risk for kidney disease. If you experience kidney failure, treatments include kidney transplant or dialysis.",
      },
      {
        imageUrl: g3,
        name: "Kidney Stone",
        desc: "Kidney stones are hard, pebble-like pieces of material that form in one or both of your kidneys when high levels of certain minerals are in your urine.",
      },
      {
        imageUrl: g4,
        name: "G.Bladder Stone",
        desc: "Gallstones are hardened deposits of digestive fluid, called bile, that form in the gallbladder. They can range in size from a grain of sand to a golf ball. ",
      },
      {
        imageUrl: g5,
        name: "Liver Diseases",
        desc: "Liver disease is a general term for conditions that prevent the liver from functioning properly. The liver is a large organ that performs many vital functions",
      },
      {
        imageUrl: g6,
        name: "Paralysis",
        desc: " Paralysis is the loss of muscle function in some or all of the body, which can be temporary or permanent. It occurs when the messages between the brain and muscles are disrupted",
      },
      {
        imageUrl: g7,
        name: "Prostate Enlargement",
        desc: "Prostate enlargement, also known as benign prostatic hyperplasia (BPH), is a condition where the prostate gland increases in size. It's a common condition that affects many men",
      },
    ],
  };
 
 
  return (
    <div className="home-container">
      <HeaderCaraousel />
      <div className="content-sec-1">
        <div className="content-sec-1-1">
          <h1 className="content-h1">About Homeopathy</h1>
          <p className="content-p1">What Is Homeopathy?</p>
          {isMobile ? (
            <div className="content-sec-1-2">
              <img src={sec1} />
            </div>
          ) : (
            ""
          )}
          <p className="content-p2">
            Homeopathy is a gentle, yet powerful form of medicine that is rooted
            in natural healing principles. It works by stimulating the body’s
            inherent ability to heal itself, using highly diluted remedies
            derived from plants, minerals, or animals. Unlike conventional
            medicine that focuses on treating symptoms with medications,
            homeopathy aims to treat the root causes of illness in a holistic
            manner.
          </p>
        </div>
        {!isMobile ? (
          <div className="content-sec-1-2">
            <img src={sec1} />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="content-sec-2">
        <h1 className="content-h1">Homeopathy Treatments</h1>
        <p className="content-p1">Our Treatments</p>
        <p className="content-p2">
          Homeopathic treatment is individualized, meaning that two people with
          the same condition might receive different remedies based on their
          unique physical, emotional, and mental states.
        </p>
      </div>
      <div className="content-sec-3">
        <ContentCard skin={skin} />
      </div>
      <div className="content-sec-3">
        <ContentCard skin={female} />
      </div>
      <div className="content-sec-3">
        <ContentCard skin={general} />
      </div>
      <div className="content-sec-3">
        <OnlineConsultation handleAppointment={handleAppointment} />
      </div>
      <div className="content-sec-4">
        <div className="content-sec-4-1">
          <h1
            className="skin-head-1"
            style={{ fontSize: isMobile ? "35px" : "42px" }}
          >
            Take care of your health doesn't have to be difficult
          </h1>
          <p className="skin-head-para" style={{ marginTop: "0px" }}>
            Were constantly finding ways to make it easy so that can get better
            and stay that way
          </p>
          <button
            className="content-btn"
            style={{ width: isMobile ? "50%" : "24%" }}
          >
            Know more
          </button>
        </div>
        <div className="content-sec-4-img">
          <img src={sec4} />
        </div>
      </div>
      <div className="content-sec-4">
        <div className="content-sec-4-img">
          <img src={sec5} />
        </div>
        <div className="content-sec-4-2">
          <h1
            className="skin-head-1"
            style={{ fontSize: isMobile ? "28px" : "42px" }}
          >
            Why Choose Homeopathy?
          </h1>
          <ul>
            <li>
              Natural and Non-Toxic: Homeopathic remedies are made from natural
              substances and are free from harmful side effects.
            </li>
            <li>
              Personalized Treatment: Every remedy is selected based on your
              unique physical and emotional state.
            </li>
            <li>
              Safe for All Ages: Homeopathy is safe for children, adults, and
              even pets.
            </li>
            <li>
              Holistic Approach: Homeopathy treats the person as a whole,
              focusing on mental, emotional, and physical aspects of health.
            </li>
            <li>
              Proven Track Record: Thousands of years of combined clinical and
              anecdotal evidence support the effectiveness of homeopathy.
            </li>
          </ul>
        </div>
      </div>

      <div className="content-sec-5">
        <div className="content-sec-5-1">
          <h1 className="skin-head-1" style={{ fontSize: "42px" }}>
            Welcome To HOMOEOPATHIC HEALTH CARE & RESEARCH CENTER
          </h1>
          <p className="skin-head-para" style={{ marginTop: "0px" }}>
            Our team of highly trained professionals uses the latest healing
            technologies to restore you to pain-free health quickly and easily.
          </p>
          <div className="doctor-treatment-name">
            <div className="doctor-treatment-name-1">
              {/* <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">
                  C.C.H. (Child Health) Consultant Physician
                </p>
              </div>
             
              <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">
                  B.H.M.S , D.N.Y.T, S.V.D. (Skin & Venereal)
                </p>
              </div> */}
              <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">24 Hours Medical Service</p>
              </div>
              <div>
                <IoMdCheckmarkCircleOutline
                  size={40}
                  color="var(--primary-color)"
                />
                <p className="doctor-p1">Multi Specialty Clinic</p>
              </div>
            </div>
            <div className="doctor-btn-book-div">
              <button className="doctor-btn-book-1" onClick={handleAppointment}>
                Book An Appointment
              </button>
            </div>
          </div>
        </div>
        <div className="content-sec-5-img">
          <img src={sec6} />
        </div>
      </div>

      {/* <div className="content-sec-6">
        <GetAnAppointment />
      </div> */}
      <VideoCaraousel />
      <div className="content-sec-7">
        <div className="content-h1-p">
          <h1 className="content-h1">Testimonials</h1>
          <p className="content-p1">What our patient says</p>
          <p className="content-p1">
            Here are a few heartfelt testimonials from our patients who have
            experienced the transformative power of homeopathy at HOMOEOPATHIC
            HEALTH CARE & RESEARCH CENTER. We are grateful to be a part of their
            healing journeys and are proud of the positive impact homeopathy has
            had on their lives.
          </p>
        </div>

        <TestimonialData options={options}/>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </div>
  );
};

export default Home;
